<template>
  <b-row>
    <b-col v-if="isLoading && items.length === 0">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <!--<b-col cols="12">-->
          <!--<div-->
          <!--v-if="isLoading"-->
          <!--class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <!--<div-->
                  <!--v-if="deletedItem"-->
                  <!--class="alert alert-success">{{ deletedItem['brandTitle'] }} deleted.</div>-->
          <!--<div-->
                  <!--v-if="error"-->
                  <!--class="alert alert-danger">{{ error }}</div>-->
        <!--</b-col>-->
        <b-col cols="12">
          <b-row>
            <b-col class="text-right">
              <router-link
                :to="{ name: 'EXCMDeviceBrandCreate' }"
                class="btn btn-primary">{{$t('buttons.create')}}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div v-if="items.length > 0">
              <table class="table table-sm table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.excmdevicebrand.list.brandTitle')}}</th>
                  <th />
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="item in items"
                        :key="item['@id']">
                  <td>
                    {{ item['brandTitle'] }}
                    <!--                  <router-link-->
                    <!--                    v-if="item"-->
                    <!--                    :to="{name: 'EXCMDeviceBrandUpdate', params: { id: item['@id'] }}">-->
                    <!--                    {{ item['brandTitle'] }}-->
                    <!--                  </router-link>-->
                  </td>
                  <td>
                    <router-link :to="{name: 'EXCMDeviceBrandUpdate', params: { id: item['@id'] }}">
                      <button class="float-right btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p v-else>{{ $t('views.excmdevicebrand.list.noBrands') }}</p>
            <div v-if="view">
              <pagination
                :view="view"
                @getPage="getPage($event)"
              ></pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'excmdevicebrand/del/deleted',
    error: 'excmdevicebrand/list/error',
    items: 'excmdevicebrand/list/items',
    isLoading: 'excmdevicebrand/list/isLoading',
    view: 'excmdevicebrand/list/view'
  }),

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceBrandList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmdevicebrand/list/default'
  })
}
</script>
